import _ from 'lodash';

 const getUserDetailsFromStorage = () => {
    let userD: any = localStorage.getItem('patmy');
    if (userD) {
        userD = JSON.parse(userD);
        return userD;
    }
    else
        return {};
   }
const checkModulePermission = (module: any, key: any) => {
    module = module === "testpapers" ? "test" : module;
    module = module === "studymaterial" ? "studyMaterial": module;
    let user =  getUserDetailsFromStorage();
    user =  user && user.authenticatedUser;
    return(Boolean(user && user.role && user.role.permissions && user.role.permissions.filter(function(val: any) {
      if (val.module === module) {
        return val.access.includes(key);
      }
      }).length));
  }

const hasAccessTo = (layerType: string[], accessType: string[], userDetail: any = {}) => {
    if (_.isEmpty(userDetail)) {
			userDetail = getUserDetailsFromStorage();
		}

    let hasAcc: boolean = false;

    const roles: any[] = userDetail && userDetail.authenticatedUser && userDetail.authenticatedUser.roles && userDetail.authenticatedUser.roles.length > 0 ? userDetail.authenticatedUser.roles : [];
    const role = roles && roles.length > 0 ? roles[userDetail.selectedRoleIndex] : {};

    if (role && (role.roleId && role.roleId.allowAll || userDetail.authenticatedUser && userDetail.authenticatedUser.isAdmin)) {
        hasAcc = true;
    }
    else if (role && role.roleId) {
        let roleData = role.roleId;
        let a = roleData.featureLevelPermissions ? roleData.featureLevelPermissions.filter((role: any) => layerType.includes(role.featureType) && role.accessAllowed.some((r: any) => accessType.includes(r))) : [];
        hasAcc = a && a.length > 0 ? true : false;
    }
    return hasAcc;
}

const responseHasAccessTo = (response: any[], accessType: string[], layerType: string[], responseKey: string, checkBoth: Boolean) => {
    let userDetail: any = {};
    //@ts-ignore
    if (!window["userDetail"]) {
        userDetail = getUserDetailsFromStorage();
        //@ts-ignore
        window["userDetail"] = userDetail;
    } else {
        //@ts-ignore
        userDetail = window["userDetail"];
    }
    const userId = _.get(userDetail, 'authenticatedUser._id', '');
    
		let hasBothAcc = false;
		let hasResponseAcc = false;
		let hasDefaultAcc = false;

		switch(responseKey) {
			case 'allowedTo': {
				const allowedToData = _.find(_.get(response, 'allowedTo', []), ['user.id._id', userId]);
			
				if(_.isUndefined(allowedToData) || _.isNull(allowedToData) || _.isEmpty(allowedToData)) {
						hasResponseAcc = true;
				} else {
						const hasAccessAllowed:any = _.filter(allowedToData.accessAllowed, d => _.includes(accessType, d)) || [];
						hasResponseAcc = hasAccessAllowed && hasAccessAllowed.length > 0 ? true : false;
				}
			}
			break;

			case 'createdBy': {
				const createdByData = _.get(response, 'createdBy.id', '');

				if (!_.isEmpty(createdByData) && _.isEqual(createdByData, userId)) {
					hasResponseAcc = true;
				} else {
					hasResponseAcc = false;
				}
			}
			break;
		}

		if (!_.isEmpty(layerType)) {
			hasDefaultAcc = hasAccessTo(layerType, accessType, userDetail);
		}

		if (checkBoth) {
			hasBothAcc = hasDefaultAcc && hasResponseAcc;
		} else {
			hasBothAcc = hasDefaultAcc || hasResponseAcc;
		}

		return hasBothAcc;
}

const switchRole = (index: number) => {


    //Update Localstorage and windows userDetails
    let userD: any = localStorage.getItem('patmy');
    if (userD) {
        userD = JSON.parse(userD);
        userD["selectedRoleIndex"] = index;
        localStorage.setItem('patmy', JSON.stringify(userD));
        //@ts-ignore
        window["userDetail"] = userD;
        location.reload();
    }
}

const getUserReviewer = () => {
    let reviewer = [];
    let userDetail: any = localStorage.getItem('patmy');
    if (userDetail) {
        userDetail = JSON.parse(userDetail);
        let roles: any[] = userDetail && userDetail.authenticatedUser && userDetail.authenticatedUser.roles && userDetail.authenticatedUser.roles.length > 0 ? userDetail.authenticatedUser.roles : [];
        let role = roles && roles.length > 0 ? roles[userDetail.selectedRoleIndex] : {};
        reviewer = role.reviewer ? role.reviewer : [];
    }
    return reviewer;
}
const isSuperAdmin = () => {
    let userDetail: any = localStorage.getItem('patmy');
    if (userDetail) {
        userDetail = JSON.parse(userDetail);
        return userDetail && userDetail.authenticatedUser && userDetail.authenticatedUser.isSuperAdmin;
    }
}

const ACLService = {
    hasAccessTo,
    responseHasAccessTo,
    switchRole,
    getUserReviewer,
    getUserDetailsFromStorage,
    checkModulePermission,
    isSuperAdmin
}

export default ACLService;